import { createRequestActionTypes } from "../../../shared/utility";

export const MerchantMngActions = {
    fetchMerchantMetadata: createRequestActionTypes('FETCH_MERCHANT_METADATA'),
    fetchMerchantDetails: createRequestActionTypes('FETCH_MERCHANT_DETAILS'), 
    createMerchant: createRequestActionTypes('CREATE_MERCHANT'),
    fetchCIBProrgamPicklist: createRequestActionTypes('FETCH_CIB_PROGRAM_PICKLIST'),
    fetchMIBProrgamPicklist: createRequestActionTypes('FETCH_MIB_PROGRAM_PICKLIST'),
    fetchBrandProrgamPicklist: createRequestActionTypes('FETCH_BRAND_PROGRAM_PICKLIST')
}